<template>
    <b-modal
        :id="`modal-add-products`"
        ref="modal"
        :title="$t('addProducts')"
        size="lg"
        ok-variant="primary"
        :ok-title="$t('save')"
        static
        centered
        ok-only
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >

        <FormValidator :validator="$v.form.products" form-group v-slot="slotProps" :label="$t('products')">
            <FormProductTreeSelect
                ref="FormProductTreeSelect"
                v-model="form.products"
                :disabled="requestGroupProducts.getAnyLoading()"
                :state="slotProps.state"
                :disabled-nodes="usedIds"
            />
        </FormValidator>

        <ErrorMessage v-for="(error, index) in errors" :key="index" :value="error" />

        <template #modal-footer="{ ok }">
            <ButtonIcon :loading="requestGroupProducts.getAnyLoading()" class="wide" @click="ok">
                {{ $t('save') }}
            </ButtonIcon>
        </template>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';
    import FormProductTreeSelect from '@/components/common/FormProductTreeSelect.vue';

    export default {
        name: 'ModalAddProducts',
        components: {
            FormValidator,
            FormProductTreeSelect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestGroupProducts: this.$req('producerProductGroups/GroupProducts'),
                errors: [],
                form: {
                    products: [],
                },
            };
        },
        validations() {
            return {
                form: {
                    products: { required },
                },
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            groupId() {
                return this.parentComponent.id;
            },
            usedIds() {
                return this.parentComponent.item?.products.map(item => item.id) || [];
            },
        },
        methods: {
            addProduct(id) {
                return this.requestGroupProducts
                    .id(`${this.groupId}-${id}`)
                    .post({ urlParams: { groupId: this.groupId, id } })
                    .then(() => id);
            },
            handleSubmit() {
                const promises = this.form.products.map(this.addProduct);
                Promise.allSettled(promises).then(results => {
                    if (results.some(item => item.status === 'rejected')) {
                        results.forEach(result => {
                            if (result.status === 'fulfilled') {
                                const index = this.form.products.indexOf(result.value);
                                if (index > -1) {
                                    this.form.products.splice(index, 1);
                                }
                            } else if (result.status === 'rejected') {
                                this.errors.push(result.reason);
                            }
                        });
                    } else {
                        this.$refs.modal.hide();
                    }
                    if (results.some(item => item.status === 'fulfilled')) {
                        results.forEach(result => {
                            const node = this.$refs.FormProductTreeSelect.$refs.FormTreeSelect.$refs.TreeSelect.getNode(result.value);
                            node.isDisabled = true;
                        });
                        this.parentComponent.fetchData();
                    }
                });
            },
            resetData() {
                this.form.products = [];
                this.errors = [];
            },
        },
    };
</script>
